import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import App from './App.vue'
import store from './store'
import {
  Button, Tabbar, TabbarItem, Tab, Tabs,
  Swipe, SwipeItem, Lazyload, Col, Row,
  Icon, Image as VanImage, Tag, Divider, CountDown,
  NavBar, DropdownMenu, DropdownItem, Sticky,
  Form, Field, Checkbox, CheckboxGroup, NoticeBar,
  Dialog, ShareSheet, Notify, Loading, Popover, List,
  PullRefresh, Grid, GridItem, Search, Cell, CellGroup,
  ActionSheet, Overlay, Collapse, CollapseItem,
  Step, Steps, Uploader
} from 'vant'
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@/assets/fonts/iconfont.css';

const plugins = [VueRouter, Button, Tabbar, TabbarItem, Tab, Tabs,
  Swipe, SwipeItem, Lazyload, Col, Row,
  Icon, VanImage, Tag, Divider, CountDown,
  NavBar, DropdownMenu, DropdownItem, Sticky,
  Form, Field, Checkbox, CheckboxGroup, NoticeBar,
  Dialog, ShareSheet, Notify, Loading, Popover, List,
  PullRefresh, Grid, GridItem, Search, Cell, CellGroup,
  ActionSheet, Overlay, Collapse, CollapseItem,
  Step, Steps, Uploader
]

plugins.forEach(plugin => Vue.use(plugin))

Vue.config.productionTip = false
// ✅ 关键配置：全局捕获 Vue 组件内的错误
Vue.config.errorHandler = function (err, vm, info) {
  // 1. 阻止错误继续向上抛出
  // 2. 在这里你可以做任何事：上报日志、显示友好的用户提示等

  // 如果你在开发环境想要隐藏错误遮罩，可以 console.warn 代替 console.error
  // 但最佳实践是：生产环境记录日志，开发环境保留以便调试。
  console.warn('【Vue 错误】', err, info);
  
  // 生产环境：可上报到监控平台（如 Sentry）
  // if (process.env.NODE_ENV === 'production') {
  //   reportErrorToServer(err, info);
  // }
};
// ✅ 捕获所有未处理的 Promise 异常 (例如 .catch() 没写的)
window.addEventListener('unhandledrejection', (event) => {
  console.warn('【未处理的 Promise 错误】', event.reason);
  // 可以阻止默认行为（某些浏览器会打印红字报错，但不会影响界面）
  event.preventDefault();
});

// ✅ 捕获所有未捕获的同步错误（备用方案）
window.addEventListener('error', (event) => {
  console.warn('【未捕获的 JS 错误】', event.message);
  // 阻止默认行为（某些浏览器会显示错误页面）
  event.preventDefault();
  return true;
});

new Vue({
  render: h => h(App),
  router,
  store,
  beforeCreate() {
    // 注册全局消息总线
    Vue.prototype.$bus = this;
  }
}).$mount('#app')
